<template lang='pug'>
div
    transition(name='van-slide-right')
        .float-group(v-show='showContact')
            .chat(@click='goLink')
                img(src='@/assets/imgs/concat.png')
                span 人工客服
            van-icon.hide(name='arrow', @click='showContact = false')
    .float-group(v-show='!showContact')
        van-icon.show(name='arrow-left', @click='showContact = true')
</template>

<script>
import createNew from '@/views/ticket/createNew'
export default {
    mixins: [createNew],
    data() {
        return {
            showContact: true
        }
    },
    methods: {
        goLink(){
            window.location.href = window.env.VUE_APP_CONTACT_URL
        }
    }
}
</script>

<style scoped lang='less'>
.float-group {
    position: fixed;
    right: 2px;
    bottom: 24%;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 99;
    i {
        color: @themeColor;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        border-radius: 50%;
        font-size: 1rem;
        background: #fff;
    }
    .show {
        transform: translateX(50%);
    }
    .hide {
        margin-top: 0.3rem;
    }
    .chat {
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        border-radius: 50%;
        color: @themeColor;
        img {
            width: 1.2rem;
            object-fit: contain;
        }
        > span {
            font-size: 0.45rem;
        }
    }
}
</style>